const groupDocumentDigits = (digits: string) =>
  digits.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

export const formatDocumentNumber = (document: unknown) => {
  const rawDocument = String(document ?? "").trim();
  if (!rawDocument) return "";
  if (!/^[\d\s.,-]+$/.test(rawDocument)) return rawDocument;

  const isGroupedWithDots = /^\d{1,3}(\.\d{3})+$/.test(rawDocument);
  const integerPart = rawDocument.includes(",")
    ? rawDocument.split(",")[0]
    : /^\d+\.\d+$/.test(rawDocument) && !isGroupedWithDots
      ? rawDocument.split(".")[0]
      : rawDocument;
  const digits = integerPart.replace(/\D/g, "");

  return digits ? groupDocumentDigits(digits) : rawDocument;
};

export const formatIdentificationDocument = (
  identificationType: unknown,
  document: unknown,
) => {
  const type = String(identificationType ?? "V").trim() || "V";
  const formattedDocument = formatDocumentNumber(document);

  return [type, formattedDocument].filter(Boolean).join(" ");
};
